import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {Button, FormControl, InputLabel, MenuItem, Paper, Select} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab";
import {Tab} from '../Tab';
import {PopupDialog} from '../../core/components/PopupDialog';
import {t} from "../../core/localization";
import {EntityField} from "../../core/genericdocuments/EntityField";
import {FieldView} from "../components/FieldView";
import {Utility} from "../../core/Utility";
import {Document, DocumentTypes} from "../../models/Document";
import {
	actionDocumentDelete,
	actionDocumentFetch, actionDocumentIndexingNumberRequest,
	actionDocumentPerformAction,
	actionDocumentSave
} from "../../store/documents";
import {employeeContractDocumentFieldsDescriptor} from "./definitions/EmployeeContractDocumentFields";
import FileUploader from "../../core/components/FileUploader";
import {invoiceDocumentFieldsDescriptor} from "../../dms/definitions/invoice/InvoiceDocumentFields";
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor";
import {Customer} from "../../models/Customer";
import {LookupDataRow} from "../../services/LookupDataRow";
import {actionCustomerFetchAll} from "../../store/customers";
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails";
import {User} from "../../models/User";
import {actionUserFetchAll} from "../../store/users/actions";
import {Department} from "../../models/Department";
import {Position} from "../../models/Position";
import {racunDocumentFieldsDescriptor} from "../../dms/definitions/racuni/RacunDocumentFields";
import {predracunDocumentFieldsDescriptor} from "../../dms/definitions/racuni/PredracunDocumentFields";
import {poslovniUgovorDocumentFieldsDescriptor} from "../../dms/definitions/ugovori/PoslovniUgovorDocumentFields";
import {avansniRacunDocumentFieldsDescriptor} from "../../dms/definitions/racuni/AvansniRacunDocumentFields";
import {ugovorORaduDocumentFieldsDescriptor} from "../../dms/definitions/hr/UgovorORaduDocumentFields";
import {aneksUgovoraDocumentFieldsDescriptor} from "../../dms/definitions/ugovori/AneksUgovoraDocumentFields";
import {actionDepartmentsFetchAll} from "../../store/departments";
import {zaKabinetDocumentFieldsDescriptor} from "../../dms/definitions/kabinet/ZaKabinetDocumentFields";
import {inoFakturaDocumentFieldsDescriptor} from "../../dms/definitions/racuni/InoFakturaFields";
import {obracunProvizijeDocumentFieldsDescriptor} from "../../dms/definitions/polise/ObracunZaProvizijuDocumentFields";
import {racunZaProvizijuDocumentFieldsDescriptor} from "../../dms/definitions/polise/RacunZaProvizijuDocumentFields";
import {raskidUgovoraORaduDocumentFieldsDescriptor} from "../../dms/definitions/hr/RaskidUgovoraORaduDocumentFields";
import {predlogZaSaradnjuDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/PredlogZaSaradnjuDocumentFields";
import {kompenzacijaDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/KompenzacijaDocumentFields";
import {otpremnicaDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/OtpremnicaDocumentFields";
import {actionPositionFetchAll} from "../../store/positions";
import {actionEmployeeFetchAll} from "../../store/employees";
import {Employee} from "../../models/Employee";
import {getDerivedValue} from "../../core/genericdocuments/EntityFieldsUtil";
import {validate} from "../../core/ValidationUtil";
import {zahtevZaRaskidPoliseDocumentFieldsDescriptor} from "../../dms/definitions/polise/ZahtevZaRaskidPoliseDocumentFields";
import {zahtevZaPogresnoUplacenaSredstvaFieldsDescriptor} from "../../dms/definitions/polise/ZahtevZaPogresnoUplacenaSredstvaDocumentFields";
import {ponudaDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/PonudaDocumentFields";
import {zapisnikOIzvrsenomPosluDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/ZapisnikOIzvrsenomPosluDocumentFields";
import {potvrdaOPrijaviSteteDocumentFieldsDescriptor} from "../../dms/definitions/stete/PotvrdaOPrijaviSteteDocumentFields";
import {prigovorZaStetuDocumentFieldsDescriptor} from "../../dms/definitions/stete/PrigovorZaStetuDocumentFields";
import {zakljucakIzvrsiteljaDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/ZakljucakIzvrsiteljaDocumentFields";
import {opomenaZaSudskuTaksuDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/OpomenaZaSudskuTaskuDocumentFields";
import {zahtevZaRadniOdnosDocumentFieldsDescriptor} from "../../dms/definitions/hr/ZahtevZaRadniOdnosDocumentFields";
import {izvodOtvorenihStavkiDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/IzvodOtvorenihStavkiDocumentFields";
import {potvrdaOSprecenostiZaRadDocumentFieldsDescriptor} from "../../dms/definitions/hr/PotvrdaOSprecenostiZaRadDocumentFields";
import {zahtevZaOdsustvovanjeDocumentFieldsDescriptor} from "../../dms/definitions/hr/ZahtevZaOdsustvovanjeDocumentFields";
import {izvestajRevizijeDocumentFieldsDescriptor} from "../../dms/definitions/ostalo/IzvestajRevizijeDocumentFields";
import {actionToastrInfo} from "../../store/global";
import {actionSetTabState} from "../../store/tabs/actions";
import {zahtevZaPovratPotpunDocumentFieldsDescriptor} from "../../dms/definitions/racuni/ZahtevZaPovratPotpunDocumentFields";

export interface DocumentTabProps extends BaseTabProps{
	tab: Tab,
	customers: Customer[]
	users: User[]
	departments: Department[]
	positions: Position[]
	employees: Employee[]
	indexingNumber: string,
	stateItem: any
}

export interface DocumentTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validationState: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		stateItem: state.tabs.active.state.item,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		customers: state.customers.list,
		departments: state.departments.list,
		positions: state.positions.list,
		employees: state.employees.list,
		users: state.users.list,
		indexingNumber: state.documents.indexingNumber
	};
}

class DocumentTab extends BaseTab<DocumentTabProps, DocumentTabState> {

	constructor(props: DocumentTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validationState: null}
	}

	componentDidMount() {
		actionCustomerFetchAll()
		actionUserFetchAll()
		actionDepartmentsFetchAll()
		actionPositionFetchAll()
		actionEmployeeFetchAll()
		actionDocumentIndexingNumberRequest()
		if (this.props.item && this.props.item.id) actionDocumentFetch(this.props.item)
	}

	componentWillMount() {
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		if (!this.props.item || (this.props.item && this.props.item.notAllowed)) {
			return <div style={{padding: '20px'}}>Nemate pravo da pristupite ovom dokumentu</div>
		}

		return (
			<div style={{padding: '10px'}}>
				{this.renderTabControls()}
				<div style={{display:'flex', flexDirection:'row', flex:'2', marginTop: '10px' }}>
					<div style={{flex:'1', marginRight: '20px'}}>
						<Paper style={{padding:'10px'}}>
							{this.renderForm()}
							{this.renderControls()}
						</Paper>
					</div>
					<div style={{flex:'1'}}>
						<Paper style={{padding:'10px'}}>
							{this.props.item && this.props.item.id && <FileUploader
								itemId={this.props.item.id}
								itemType={'Documents'}
								uploads={this.props.item.uploads}
								onUpload={this.onUpload.bind(this)}
								onDelete={this.onFileDelete.bind(this)}/>}
							{(!this.props.item || !this.props.item.id) && <p style={{textAlign: 'center'}}>{t.SaveItem}</p>}
						</Paper>
					</div>
				</div>
				{/*{this.renderDeleteConfirmationDialog()}*/}
				{this.renderPopupDialog()}
			</div>
		);
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = null
		let type = Utility.formatString(this.getItemFromTabState('type'))
		if (type) {
			descriptor = this.getCreateFieldsDescriptor(type as DocumentTypes)
		}

		let tabState = this.props.state
		let formState = tabState['item'] && tabState['item']['fields'] ? tabState['item']['fields'] : this.props.item['fields']

		return (<div className="create-form">
			<div>Status: {this.props.item.state}</div>
			{
				descriptor && descriptor.createFormFields.map(
					(entityField: EntityField<any>, index: number) => {
						const fieldName = entityField.name.toString()
						let value = Utility.formatString(this.getGenericItemFromTabState(fieldName))
						return (
							<div style={{ marginBottom: "0px", padding: "0px" }}>
								{this.isFieldVisible(entityField, descriptor.createFormFields) &&
									<FieldView value={value}
										autoFocus={index === 0} field={entityField} formState={formState}
										setFormState={null}
										handleInputChange={(fieldName, value) => this.handleGenericInputChange(fieldName, value)}
										validationState={this.state.validationState}
										lookupData={this.getLookupData.bind(this)}
									/>
								}
							</div>
						);
					}
				)
			}
			{(this.props.item && this.props.item.type == DocumentTypes.Undefined) &&
				<FormControl required style={{width: '100%', marginTop:'20px'}} >
					<InputLabel htmlFor="age-required">Tip dokumenta</InputLabel>
					<Select
						value={Utility.formatString(this.getItemFromTabState('type'))}
						onChange={(e) => {this.handleItemSelectChange(e, 'type')}}
						name="categoryId"
						required={true}
						style={{width: '100%'}}>z
							<MenuItem key={'undefined'} value='undefined'>Undefined</MenuItem>
							<MenuItem key={'predracun'} value='predracun'>Predračun</MenuItem>
							<MenuItem key={'avansni_racun'} value='avansni_racun'>Avansni račun</MenuItem>
							<MenuItem key={'racun'} value='racun'>Račun</MenuItem>
							<MenuItem key={'ino_faktura'} value='ino_faktura'>Ino faktura</MenuItem>
							<MenuItem key={'kompenzacija'} value='kompenzacija'>Kompenzacija</MenuItem>
							<MenuItem key={'otpremnica'} value='otpremnica'>Otpremnica</MenuItem>
							<MenuItem key={'obracun_provizije'} value='obracun_provizije'>Obračun provizije</MenuItem>
							<MenuItem key={'zahtev_za_povrat_potpun'} value='zahtev_za_povrat_potpun'>Zahtev za povrat sredstava - potpun</MenuItem>
							<MenuItem key={'racun_za_proviziju'} value='racun_za_proviziju'>Račun za proviziju</MenuItem>
							<MenuItem key={'poslovni_ugovor'} value='poslovni_ugovor'>Poslovni ugovor</MenuItem>
							<MenuItem key={'aneks_ugovora'} value='aneks_ugovora'>Aneks ugovora</MenuItem>
							<MenuItem key={'ugovor_o_radu'} value='ugovor_o_radu'>Ugovor o radu</MenuItem>
							<MenuItem key={'aneks_ugovora_o_radu'} value='aneks_ugovora_o_radu'>Aneks ugovora o radu</MenuItem>
							<MenuItem key={'raskid_ugovora_o_radu'} value='raskid_ugovora_o_radu'>Raskid ugovora o radu</MenuItem>
							<MenuItem key={'dokument_za_kabinet'} value='dokument_za_kabinet'>Dokument za kabinet</MenuItem>
							<MenuItem key={'predlog_za_saradnju'} value='predlog_za_saradnju'>Predlog za saradnju</MenuItem>
							<MenuItem key={'zahtev_za_raskid_polise'} value='zahtev_za_raskid_polise'>Zahtev za raskid polise</MenuItem>
							<MenuItem key={'zahtev_za_prenos_sredstava'} value='zahtev_za_prenos_sredstava'>Zahtev za prenos pogrešno uplaćenih sredstava</MenuItem>
							<MenuItem key={'ponuda'} value='ponuda'>Ponuda</MenuItem>
							<MenuItem key={'zapisnik_o_zavrsenom_poslu'} value='zapisnik_o_zavrsenom_poslu'>Zapisnik o izvršenom poslu</MenuItem>
							<MenuItem key={'potvrda_o_izvrsenoj_prijavi_stete'} value='potvrda_o_izvrsenoj_prijavi_stete'>Potvrda o izvršenoj prijavi štete</MenuItem>
							<MenuItem key={'prigovor_za_stetu'} value='prigovor_za_stetu'>Prigovor za štetu</MenuItem>
							<MenuItem key={'zakljucak_javnog_izvrsitelja'} value='zakljucak_javnog_izvrsitelja'>Zaključak javnog izvršitelja</MenuItem>
							<MenuItem key={'opomena_za_sudske_takse'} value='opomena_za_sudske_takse'>Opomena za plaćanje sudske takse</MenuItem>
							<MenuItem key={'zahtev_za_zasnivanje_radnog_odnosa'} value='zahtev_za_zasnivanje_radnog_odnosa'>Zahtev za zasnivanje radnog odnosa</MenuItem>
							<MenuItem key={'izvod_otvorenih_stavki'} value='izvod_otvorenih_stavki'>Izvod otvorenih stavki</MenuItem>
							<MenuItem key={'potvrda_o_sprecenosti_za_rad'} value='potvrda_o_sprecenosti_za_rad'>Potvrda o nastupanju privremene sprečenosti za rad</MenuItem>
							<MenuItem key={'zahtev_za_odsustvovanje'} value='zahtev_za_odsustvovanje'>Zahtev za odsustvovanje</MenuItem>
							<MenuItem key={'izvestaj_eksterne_revizije'} value='izvestaj_eksterne_revizije'>Izveštaj eksterne revizije</MenuItem>
							<MenuItem key={'invoice'} value='invoice'>Test</MenuItem>
					</Select>
					{/*<FormHelperText style={{color: '#ed1a3a'}}>{Validator.displayFormErrors(this.state.validation.fields, 'categoryId').message}</FormHelperText>*/}
				</FormControl>
			}
		</div>)
	}

	renderTabControls(): React.ReactNode {

		if (this.props.item && this.props.item.actions) {
			return this.props.item.actions.map((action: any) => {
				return (
					<Button disabled={!action.allowed} onClick={this.onActionClick.bind(this, action.name)} variant="contained" color="primary" style={{marginRight: '10px'}}>{action.label ? action.label : action.name}</Button>
				)
			})
		}
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	onSaveClick () {
		let itemToSave = this.getGenericItemFromTabState()
		const fieldsDescriptor = this.getCreateFieldsDescriptor(itemToSave.type)
		const newValidationState = validate(itemToSave.fields, fieldsDescriptor.createFormFields);

		this.setState({ ...this.state, validationState: newValidationState });
		if (newValidationState) {
			// Utility.showErrorMessage(t(r => r.COMMON.ERROR), t(r => r.COMMON.VALIDATION_ERROR));
			// this.setState({ ...this.state, validationState: newValidationState });
			return;
		}

		// this.setState({ ...this.state, validationState: newValidationState });

		// creating save item
		let document = new Document()
		document.id = this.props.item ? this.props.item.id : null
		document.parentId = itemToSave.parentId
		document.type = itemToSave.type
		document.assignedTo = itemToSave.fields.assignedTo
		document.tags = itemToSave.fields.tags
		document.visibleTo = itemToSave.fields.visbleTo
		document.indexingNumber = itemToSave.fields.indexingNumber
		document.indexingDate = itemToSave.fields.indexingDate
		document.title = Document.getTitle(document)
		document.parentId = getDerivedValue('parentId', fieldsDescriptor.createFormFields, itemToSave.fields)

		let descriptor = null
		let type = Utility.formatString(this.getItemFromTabState('type'))
		if (type) {
			descriptor = this.getCreateFieldsDescriptor(type as DocumentTypes)
		}

		descriptor.createFormFields.map((entityField: EntityField<any>, index: number) => {
			const fieldName = entityField.name.toString()
			if (Utility.isNullOrUndefined(itemToSave.fields) || Utility.isNullOrUndefined(itemToSave.fields[fieldName])) {
				if (!Utility.isNullOrUndefined(itemToSave[fieldName]))
					itemToSave.fields[fieldName] = itemToSave[fieldName]
			}
		})

		// document.fields = JSON.stringify(itemToSave.fields)
		document.fields = itemToSave.fields

		if (true) {
			actionDocumentSave(document)
			// actionActiveTabTitle(t.Category + ': ' + this.getItemFromTabState('title'))
		}

		this.setState({ ...this.state });

	}

	onActionClick(action: string) {
		console.log(action)
		let document = new Document()
		document.id = this.props.item ? this.props.item.id : null
		actionDocumentPerformAction(document, action)
	}

	getCreateFieldsDescriptor(type: DocumentTypes): EntityFieldsDescriptor<any> {
		switch (type) {
			case DocumentTypes.EmployeeContract:
				return employeeContractDocumentFieldsDescriptor
			case DocumentTypes.Invoice:
				return invoiceDocumentFieldsDescriptor
			case DocumentTypes.Racun:
				return racunDocumentFieldsDescriptor
			case DocumentTypes.Predracun:
				return predracunDocumentFieldsDescriptor
			case DocumentTypes.AvansniRacun:
				return avansniRacunDocumentFieldsDescriptor
			case DocumentTypes.PoslovniUgovor:
				return poslovniUgovorDocumentFieldsDescriptor
			case DocumentTypes.UgovorORadu:
				return ugovorORaduDocumentFieldsDescriptor
			case DocumentTypes.AneksUgovora:
				return aneksUgovoraDocumentFieldsDescriptor
			case DocumentTypes.ZaKabinet:
				return zaKabinetDocumentFieldsDescriptor
			case DocumentTypes.InoFaktura:
				return inoFakturaDocumentFieldsDescriptor
			case DocumentTypes.RacunZaProviziju:
				return racunZaProvizijuDocumentFieldsDescriptor
			case DocumentTypes.ObracunProvizije:
				return obracunProvizijeDocumentFieldsDescriptor
			case DocumentTypes.PredlogZaSaradnju:
				return predlogZaSaradnjuDocumentFieldsDescriptor
			case DocumentTypes.AneksUgovoraORadu:
				return ugovorORaduDocumentFieldsDescriptor
			case DocumentTypes.RaskidUgovoraORadu:
				return raskidUgovoraORaduDocumentFieldsDescriptor
			case DocumentTypes.ZahtezZaSanivanjeRadnogOdnosa:
				return zahtevZaRadniOdnosDocumentFieldsDescriptor
			case DocumentTypes.Kompenzacija:
				return kompenzacijaDocumentFieldsDescriptor
			case DocumentTypes.Otpremnica:
				return otpremnicaDocumentFieldsDescriptor
			case DocumentTypes.ZahtevZaRaskidPolise:
				return zahtevZaRaskidPoliseDocumentFieldsDescriptor
			case DocumentTypes.ZahtevZaPrenosSredstava:
				return zahtevZaPogresnoUplacenaSredstvaFieldsDescriptor
			case DocumentTypes.Ponuda:
				return ponudaDocumentFieldsDescriptor
			case DocumentTypes.ZapisnikOZavrsenomPoslu:
				return zapisnikOIzvrsenomPosluDocumentFieldsDescriptor
			case DocumentTypes.PotvrdaOIzvrsenojPrijaviStete:
				return potvrdaOPrijaviSteteDocumentFieldsDescriptor
			case DocumentTypes.PrigovorZaStetu:
				return prigovorZaStetuDocumentFieldsDescriptor
			case DocumentTypes.ZakljucakJavnogIzvrsitelja:
				return zakljucakIzvrsiteljaDocumentFieldsDescriptor
			case DocumentTypes.OpomenaZaSudskeTakse:
				return opomenaZaSudskuTaksuDocumentFieldsDescriptor
			case DocumentTypes.IzvodOtvorenihStavki:
				return izvodOtvorenihStavkiDocumentFieldsDescriptor
			case DocumentTypes.PotvrdaOSprecenostiZaRad:
				return potvrdaOSprecenostiZaRadDocumentFieldsDescriptor
			case DocumentTypes.ZahtevZaOdsustvovanje:
				return zahtevZaOdsustvovanjeDocumentFieldsDescriptor
			case DocumentTypes.IzvestajEksterneRevizije:
				return izvestajRevizijeDocumentFieldsDescriptor
			case DocumentTypes.ZahtevZaPovratSredstavaPotpun:
				return zahtevZaPovratPotpunDocumentFieldsDescriptor
		}
		return null
	}

	getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		switch (lookupEntity) {
			case LookupEntities.Customers: {
				return this.props.customers.map((customer: Customer) => {return {label: customer.vatId + ' -> ' + customer.title, value: customer.id}})
			}
			case LookupEntities.Users: {
				return this.props.users.map((user: User) => {return {label: `${user.firstName} ${user.lastName}`, value: user.id, data: user}})
			}
			case LookupEntities.Departments: {
				return this.props.departments.map((department: Department) => {return {label: department.title, value: department.id}})
			}
			case LookupEntities.Positions: {
				return this.props.positions.map((position: Position) => {return {label: position.title, value: position.id}})
			}
			case LookupEntities.Employees: {
				return this.props.employees.map((employee: Employee) => {return {label: `${employee.firstName} ${employee.lastName}`, value: employee.id}})
			}
		}
	}

	onUpload () {
		actionDocumentFetch(this.props.item)
	}

	onDocumentDelete () {
		actionDocumentDelete(this.props.item)
	}

	onFileDelete () {
		actionToastrInfo("Info", "File delete")
	}

	// todo: move this to document logic:
	isFieldVisible(entityField: EntityField, allFields: EntityField[]): boolean {
		if (entityField.name == 'sectorId') return true
		let indexingFieldsPopulated = true
		for (const field of allFields) {
			if (field.name == 'sectorId') {
				if (!this.getGenericItemFromTabState(field.name)) return false
			}
		}
		return true
	}
}

export default connect(mapStateToProps)(DocumentTab);
